import styles from './Switch.module.scss'

interface SwitchProps {
  checked: boolean
  onInputChange: (checked: boolean) => void
  size?: 'regular' | 'small'
  disabled?: boolean
  'aria-label'?: string
  'aria-describedby'?: string
}

const Switch = (props: SwitchProps) => {
  const { checked, onInputChange, disabled, 'aria-label': ariaLabel, 'aria-describedby': ariaDescribedBy } = props
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onInputChange(e.target.checked)
    }
  }

  const size = props.size || 'regular'

  return (
    <label
      className={`${styles.switch} ${styles[size]} ${checked ? styles.checked : ''} ${disabled ? styles.disabled : ''}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
      />
      <span className={styles.thumb} />
    </label>
  )
}

export { Switch }
